/**
 * @fileOverview The main entry point to your standalone. Start editing here.
 */

import React, { useEffect, useState } from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/reset.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/site.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/segment.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/container.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/header.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/image.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/list.css'
import './styles.scss'
import { ThemeSwitch } from '@ta-interaktiv/react-theme-switch'
import GetSheetDone from 'get-sheet-done'
import { parseHostname } from '@ta-interaktiv/parse-hostname'

const unauthorizedTenants = ['lematin', '20min']
const isUnauthorized = parseHostname().publicationName.search(unauthorizedTenants.join('|')) !== -1

export function AppComponent() {
  const SHEET_ID = '11bvNzi1rD0snNAKL7oVoafBfCU8VTSUW5cTIRCMO0EQ'
  const [isLoading, setIsLoading] = useState(true)
  const [questionsCount, setQuestionsCount] = useState(0)
  const [questions, setQuestions] = useState([])
  const [texts, setTexts] = useState({})
  const [selectedQuestion, setSelectedQuestion] = useState('')
  const [intervalId, setIntervalId] = useState()
  const [lastUpdate, setLastUpdate] = useState(new Date())
  const DATEOPTIONS = {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric'
  }

  useEffect(() => {
    // In case the spreadsheet goes down
    /* d3fetch.dsv(",", "https://www.24heures.ch/extern/interactive_wch/2020/2020-03-covid19-questions-reponses/data-1.csv", function(d) {
      return d
    }).then(function(data) {
      console.log(data)
    }) */

    // Get the title, intro, update and credits
    GetSheetDone.labeledCols(SHEET_ID, 5).then((sheet: sheetProps) => {
      const data = sheet.data[0]

      setLastUpdate(new Date(data['màj']))
      setTexts({
        title: data.titre,
        intro: data.chapeau,
        credits: {
          texts: data.textes,
          project: data.projet
        }
      })
    })

    // Get the questions/answers data
    GetSheetDone.labeledCols(SHEET_ID, 1).then((sheet: sheetProps) => {
      if (sheet.data) {
        const questions = []

        sheet.data.map(d => {
          // Push the question to the right category array
          questions.push({
            id: d.id,
            question: d.questionfr,
            answer: d.answerfr,
            category: d.category,
            sources: d.sourcesfr,
            new: d.new
          })
        })

        setQuestionsCount(sheet.data.length)
        setQuestions(questions)
        setIsLoading(false)

        /* id = setInterval(() => {
          setSelectedQuestion(questions[Math.floor(Math.random() * questions.length)].question)
        }, 3000)
        setIntervalId(id) */
      }
    })

    // return () => clearInterval(id)
  }, [])

  return (
    !isUnauthorized && (
      <div className='index'>
        <ThemeSwitch />
        <div className="image">
          <img src={require("../../images/virus.png")} />
        </div>
        <div className='text'>
          <div className='header'>
            {questions.length} questions sur le coronavirus
          </div>
          <div className='header sub'>
            Écrans tactiles? Écoles en Suisse? Femmes enceintes?
            Auto-isolement? <u>Les réponses des scientifiques</u>.
          </div>
          <div className='update'>
            <div className='live-anim'>
              <div />
              <div />
            </div>
            Màj <b>{lastUpdate.toLocaleDateString('fr-FR', DATEOPTIONS)}</b></div>
        </div>
      </div>
    )
  )
}
